const header = document.querySelector('.front-navbar');
let headerPosition = 0

function toggleHeaderSticky() {
    if (window.scrollY <= 50) {
        header.classList.remove('sticky');
    } else {
        header.classList.add('sticky');
    }
}

document.addEventListener('DOMContentLoaded', toggleHeaderSticky);
window.addEventListener('load', toggleHeaderSticky);
document.addEventListener('scroll', toggleHeaderSticky);


if (screen.width < 1024) {
    const mobileHeader = document.querySelector('.front-navbar__mobile-menu');
    const hamburgerOpen = document.querySelector('.front-navbar__hamburger-menu');
    const hamburgerClose = document.querySelector('.front-navbar__hamburger-menu--close');

    hamburgerOpen.addEventListener('click', () => {
        mobileHeader.classList.add('show');
    })

    hamburgerClose.addEventListener('click', () => {
        mobileHeader.classList.remove('show');
    })
}


document.addEventListener('DOMContentLoaded', function () {

    function createQueryStringFromSession() {
        const params = new URLSearchParams();

        const markaSessions = sessionStorage.getItem('selectedMarka');
        const modelSessions = JSON.parse(sessionStorage.getItem('selectedModels') || '[]');
        const filterParams = [
            'godina_od', 'godina_do', 'cena_od', 'cena_do',
            'karoserija', 'gorivo', 'kubikaza_od',
            'kubikaza_do', 'snaga_od', 'snaga_do', 'kilometraza_od',
            'kilometraza_do', 'menjac', 'vrata'
        ];
        filterParams.forEach(param => {
            const value = sessionStorage.getItem(param);
            if (value && value !== '' && value !== '0') {
                params.append(param, value);
            }
        });

        // MARKA
        if (markaSessions) {
            if (markaSessions && markaSessions !== '0') {
                params.append('marka', markaSessions);
            }
        }
        // MODEL
        if (modelSessions.length > 0) {
            if (modelSessions.length > 0) {
                // params.append('model', modelSessions.join(','));
                modelSessions.forEach(modelId => {
                    params.append('model[]', modelId);
                });
            }
        }

        // Dodaj sort parametar ako postoji u sesiji
        const sortValue = sessionStorage.getItem('sort');
        if (sortValue && sortValue !== '') {
            params.append('sort', sortValue);
        }
        return params.toString();

    }

    function updateMenuLinks() {
        const queryString = createQueryStringFromSession();
        const baseUrl = '/pretraga';
        const baseUrlFirst = '/ponuda';
        const finalUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        const menuItem = document.getElementById('ponuda_menu_item');
        const menuItemMobile = document.getElementById('ponuda_menu_item_mobile');
        if (queryString){
                menuItem.href = finalUrl;
                menuItemMobile.href = finalUrl;
        }else{
            menuItem.href = baseUrlFirst;
            menuItemMobile.href = baseUrlFirst;
        }
    }
        updateMenuLinks()

});
